import { useQuery } from "@apollo/react-hooks";

import { Learner } from "@hubcapp/types";
import learnersLessonsQuery from "../graph-ql/getLearnersLessons.graphql";

const useLearnersLessons = (id?: string) =>
  useQuery<{ learner: Learner }>(learnersLessonsQuery, {
    variables: {
      id,
    },
    skip: !id,
  });

export default useLearnersLessons;
